import { render, staticRenderFns } from "./CollegeSubscriptionMockTest.vue?vue&type=template&id=9ce53432"
import script from "./CollegeSubscriptionMockTest.vue?vue&type=script&lang=js"
export * from "./CollegeSubscriptionMockTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports